import { PayloadAction } from '@reduxjs/toolkit';

import {
  ConditionAddress,
  ConditionChild,
  conditionGroupChildenKey,
  DesignState,
  MediaElement,
} from 'editor/src/store/design/types';

import { removeFromPersonalizationFieldGroups } from '../util/personalizationFieldGroups';

import getConditionChildrenKey from './getConditionChildrenKey';
import getElementParentKeys from './getElementParentKeys';

const removeElementFromConditionReducer = (
  state: DesignState,
  action: PayloadAction<{
    address: ConditionAddress;
    optionId: string;
    element: MediaElement;
  }>,
) => {
  const { address, optionId, element } = action.payload;
  const { spreadIndex, conditionId } = address;
  const conditionGroup = state.designData?.spreads[spreadIndex]?.conditionGroup;
  if (!conditionGroup) {
    return;
  }

  const childrenKey = getConditionChildrenKey(conditionId, optionId);
  const field: ConditionChild = { type: element.type, id: element.uuid };
  conditionGroup.children[childrenKey] = conditionGroup.children[childrenKey].filter(
    (value) => value.type === 'condition' || value.id !== element.uuid,
  );
  removeFromPersonalizationFieldGroups(conditionGroup, field, childrenKey);

  // add back to the parent level if it's a personalisable element
  const currentParents = getElementParentKeys(conditionGroup, element.uuid);
  if (!element.personalizationLocked && currentParents.size === 0) {
    // the field was not in the top list, so any entry a top group has for it is stale
    removeFromPersonalizationFieldGroups(conditionGroup, field, conditionGroupChildenKey);
    conditionGroup.children[conditionGroupChildenKey].push(field);
  }
};

export default removeElementFromConditionReducer;
